import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useEffect, useMemo } from 'react';
import cn from 'classnames';
import styles from '../../ChatModal.module.scss';
import { ReactComponent as ArrowLeft } from '../../../../../assets/icons/arrow-left.svg';
import Heading from '../../../../Typography/Heading/Heading';
import { Field, Form, Formik } from 'formik';
import { clearChat, clearMessages, createMessage, getChat, getMessages, getNextMessages, guildChat, readMessages } from '../../../../../store/reducers/Chat/slice';
import MessageInput from '../../../../Form/MessageInput/MessageInput';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../../../../../store/reducers';
import ChatBox from './ChatBox';
import Loader from '../../../../Loader/Loader';
import { useParams } from 'react-router-dom';
import { displayName } from '../../../../LabelBox/LabelBox';
const getChatName = (chat, walletInfo) => {
    if (chat === null || chat === void 0 ? void 0 : chat.guild_name) {
        return chat.guild_name;
    }
    if (walletInfo && chat) {
        const toUser = chat.users.find((user) => user.address !== walletInfo.stakeId);
        return toUser ? displayName(toUser.name, toUser.address) : '';
    }
    return '';
};
const formInitialValues = {
    message: ''
};
const ChatSingle = ({ onSwitchToListView, memberId, singleChat, isGuildChat }) => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const { chat, page, totalPages, messages, loadingMessages } = useAppSelector((state) => state.chat);
    const { myGuildId } = useAppSelector((state) => state.guild);
    const { walletInfo } = useAppSelector((state) => state.wallet.activeWallet);
    const { id } = useParams();
    const timelineRef = React.useRef(null);
    const chatName = useMemo(() => getChatName(chat, walletInfo), [chat, walletInfo]);
    const isGroup = useMemo(() => (chat === null || chat === void 0 ? void 0 : chat.type) === 'group', [chat]);
    const hasMorePages = useMemo(() => page < totalPages, [page, totalPages]);
    const loadMessages = useCallback(() => {
        chat && dispatch(getNextMessages({ chatId: chat.id, skip: messages.length || 0 }));
    }, [dispatch, chat, messages]);
    const onFormSubmit = useCallback((values, { resetForm }) => {
        if (chat) {
            dispatch(createMessage({ chatId: chat.id, message: values.message }));
            resetForm();
        }
    }, [dispatch, chat]);
    useEffect(() => {
        if (singleChat) {
            dispatch(getChat(memberId));
        }
    }, [singleChat, dispatch, memberId]);
    useEffect(() => {
        if (isGuildChat) {
            if (id) {
                dispatch(guildChat(id));
            }
            else if (myGuildId) {
                dispatch(guildChat(myGuildId));
            }
        }
    }, [isGuildChat, dispatch, id, myGuildId]);
    useEffect(() => {
        chat && dispatch(getMessages({ chatId: chat.id }));
        return () => {
            dispatch(clearMessages());
        };
    }, [chat, dispatch]);
    useEffect(() => {
        if (messages) {
            const unreadMessages = messages.filter((message) => !message.isRead);
            if (unreadMessages.length) {
                dispatch(readMessages(unreadMessages));
            }
        }
    }, [messages, dispatch]);
    useEffect(() => {
        return () => {
            if (isGuildChat || singleChat) {
                dispatch(clearChat());
            }
        };
    }, [isGuildChat, singleChat]);
    return (_jsxs("div", Object.assign({ className: cn(styles.element, styles.single) }, { children: [_jsxs("div", Object.assign({ className: cn(styles.header, 'd-flex align-items-center') }, { children: [!singleChat && !isGuildChat && (_jsx(ArrowLeft, { className: styles.arrow, onClick: onSwitchToListView })), _jsx(Heading, { className: styles.title, size: 5, fontWeight: 500, title: chatName })] })), loadingMessages ? (_jsx(Loader, { isTransparent: true, className: styles.loader })) : (_jsx("div", Object.assign({ className: styles.chat }, { children: _jsx(ChatBox, { group: isGroup, messages: messages, loadMore: loadMessages, walletInfo: walletInfo, hasMore: hasMorePages, ref: timelineRef }) }))), _jsx(Formik, Object.assign({ initialValues: formInitialValues, onSubmit: onFormSubmit }, { children: ({ handleChange, handleBlur, values, handleSubmit }) => (_jsx(Form, Object.assign({ onSubmit: handleSubmit }, { children: _jsx(Field, { className: "w-100", type: "text", onInput: handleChange, onBlur: handleBlur, name: "message", placeholder: t('write_message'), id: "message", value: values.message, component: MessageInput, onClick: handleSubmit }) }))) }))] })));
};
export default ChatSingle;
